export default {
  state: {
    formulaMenuList:[],
    formulaNotInfoPageList:{}
  },
  getters: {
    formulaMenuList: state => {
      return state.formulaMenuList
    },
    formulaNotInfoPageList: state => {
      return state.formulaNotInfoPageList
    },
  },
  mutations: {
    setFormulaMenuList (state, list) {
      state.formulaMenuList = list
    },
    setFormulaNotInfoPageList (state, obj) {
      state.formulaNotInfoPageList = obj
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/formula.js